import { registerAppEffects } from '../repositories/account-manager/account-manager.effects';
import { registerFeatureFlagsEffects } from '../repositories/feature-flags/feature-flags.effects';

export function registerGlobalEffects() {
  registerAppEffects();
  registerFeatureFlagsEffects();
}
